<app-header [header]="header"
            [devMode]="devMode"></app-header>

<ngx-loading-bar [color]="loadingBarColor"></ngx-loading-bar>

<div class="page-content-container" [ngClass]="{'page-with-top-menu': (isHandset$ | async)}">
    @if((isHandset$ | async)){
        <top-menu [sideHeader]="sideHeader"
                  [teamMoodAdminMenu]="teamMoodAdminMenu"
                  [user]="user"></top-menu>
    }@else{
        <side-menu  [sideHeader]="sideHeader"
                    [user]="user"></side-menu>
    }

    <div id="container" class="container-fluid gx-0">
        <!-- Page Content -->
        <router-outlet></router-outlet>
    </div>
</div>
